// extracted by mini-css-extract-plugin
module.exports = {"root":"OutsideClickHandler_root__27W8Z"};